import { zeroTabStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { scrollbarStyles } from '../../../styles/styles';

export const customTabStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroTabStyles(context, definition)}
  :host([aria-selected="true"]) {
    color: var(--primary-color);
    border: 1px solid var(--border-1);
    border-bottom: none;
    background-color: #1c2024;
    box-sizing: border-box;
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 35%);
  }

  :host([aria-selected='true']:hover) {
    color: var(--primary-color);
    border: 1px solid var(--border-1);
    border-bottom: none;
    background-color: #1c2024;
    box-sizing: border-box;
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 35%);
  }

  :host([aria-selected='false']:hover) {
    background-color: #3a3c40;
    color: #fff;
  }
`;
